<div #jobOverview class="chloe-design-style relativePosition">
  <p-panel header="Job Overview" styleClass="chloe-design-style ">
    <div class="ui-g">
      <div class="ui-g-3 ui-sm-6 bold">Buy It Now:</div>
      <div class="ui-g-3 ui-sm-6">
        {{ jobInfo.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </div>

      <div class="ui-g-3 ui-sm-6 bold">Supplier Premium:</div>
      <div class="ui-g-3 ui-sm-6">
        {{ jobInfo.supplierPremium | currency : 'GBP' : 'symbol' : '1.2-2' }}
        <span style="position: relative" *ngIf="jobInfo.supplierPremium > 0">
          <i
            class="fa fa-info-circle"
            (mouseover)="showSupplierPremiums = true"
            (mouseout)="showSupplierPremiums = false"
          ></i>
          <div *ngIf="showSupplierPremiums" class="hover-tip">
            <div *ngFor="let pp of jobInfo.supplierPremiums">
              {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
              {{ pp.pricePremiumCategory?.categoryName }}
            </div>
          </div>
        </span>
      </div>
      <div class="ui-g-3 ui-sm-6 bold">Customer Premium:</div>
      <div class="ui-g-3 ui-sm-6">
        {{ jobInfo.customerPremium | currency : 'GBP' : 'symbol' : '1.2-2' }}
        <span style="position: relative" *ngIf="jobInfo.customerPremium > 0">
          <i
            class="fa fa-info-circle"
            (mouseover)="showCustomerPremiums = true"
            (mouseout)="showCustomerPremiums = false"
          ></i>
          <div *ngIf="showCustomerPremiums" class="hover-tip">
            <div *ngFor="let pp of jobInfo.customerPremiums">
              {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
              {{ pp.pricePremiumCategory?.categoryName }}
            </div>
          </div>
        </span>
      </div>
      <div class="ui-g-3 ui-sm-6 bold">Scheduled:</div>
      <div class="ui-g-3 ui-sm-6">{{ jobInfo.scheduledDate | datex : 'ddd DD MMM' }}</div>
      <div class="ui-g-3 ui-sm-6"></div>
      <div class="ui-g-3 ui-sm-6"></div>
    </div>
  </p-panel>
</div>

<div #taskDetails class="chloe-design-style relativePosition mt-2">
  <p-panel header="Task Details" styleClass="chloe-design-style no-padding-panel ">
    <p-tabView class="no-widget-border no-padding-tab">
      <p-tabPanel *ngFor="let task of jobInfo.tasks" [header]="task.vehicle.registrationNumber">
        <div class="ui-g">
          <div class="ui-g-12">
            <span class="vrm">{{ task.vehicle.registrationNumber }}</span> {{ task.vehicle.make }}
            {{ task.vehicle.model }} {{ task.vehicle.kerbWeight }}
            kg.
          </div>

          <div class="ui-g-12">
            <div class="ui-g-1 ui-sm-2 vertical-center-container">
              <i class="vme-material-icons vertical-center-content pick-up-color">&#xe805;</i>
            </div>
            <div class="ui-g-11 ui-sm-10">
              <div class="bold">
                {{ task.pickupEarliestDateTime | datex : 'ddd DD MMM HH:mm' }} -
                {{ task.pickupLatestDateTime | datex : 'ddd DD MMM HH:mm' }}
              </div>
              <div>{{ inboxjobsService.addressStr(task.pickupLocation) }}</div>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-g-1 ui-sm-2 vertical-center-container">
              <i class="vme-material-icons vertical-center-content drop-off-color">&#xe804;</i>
            </div>
            <div class="ui-g-11 ui-sm-10">
              <div class="bold">
                {{ task.dropoffEarliestDateTime | datex : 'ddd DD MMM HH:mm' }} -
                {{ task.dropoffLatestDateTime | datex : 'ddd DD MMM HH:mm' }}
              </div>
              <div>{{ inboxjobsService.addressStr(task.dropoffLocation) }}</div>
            </div>
          </div>

          <div class="ui-g-12" style="text-align: right">
            <span style="color: gray"
              >{{ mapService.getMiles(task.distance) }} miles, approx.
              {{ task.estimateTimeHHmm }}</span
            >
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </p-panel>
</div>
